import React, { useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import PurchaseInfo from "../../Common/CartInfo";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router";
import { Field, Formik } from "formik";
import { Switch, TextField } from "formik-material-ui";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";
import { getAuthInfo } from "../../../../Store/api.slice";
import { get, keys, isEmpty, omitBy } from 'lodash';
import { Autocomplete, ToggleButtonGroup } from "formik-material-ui-lab";
import { ToggleButton } from "@material-ui/lab";
import { states } from "../../../Common/USStates";
import MuiTextField from "@material-ui/core/TextField";


import { getAllParkers, getPayorData, setPayorData } from "../../../../Store/purchase.slice";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export function PayorPage() {
    const history = useHistory();
    const dispatch = useDispatch();
    const parkers = useSelector(getAllParkers);
    const payorData = useSelector(getPayorData);
    const authInfo = useSelector(state => getAuthInfo(state));
    const initDefault = (key) => !isEmpty(payorData[key]) ? payorData[key] : '';
    const init = {
        type: get(payorData, 'type', 'INDIVIDUAL'),
        status: get(payorData, 'status', 'ACTIVE'),
        billing_firstname: initDefault('billing_firstname'),
        billing_lastname: initDefault('billing_lastname'),
        billing_phone: initDefault('billing_phone'),
        billing_work_phone: initDefault('billing_work_phone'),
        billing_email: initDefault('billing_email'),
        billing_street: initDefault('billing_street'),
        billing_city: initDefault('billing_city'),
        billing_state: initDefault('billing_state'),
        billing_zip: initDefault('billing_zip'),
        info_street: initDefault('info_street'),
        info_city: initDefault('info_city'),
        info_state: initDefault('info_state'),
        info_zip: initDefault('info_zip'),
    };
    const scheme = Yup.object({
        type: Yup.string().oneOf(['INDIVIDUAL', 'BUSINESS']).required(),
        billing_firstname: Yup.string().required(),
        billing_lastname: Yup.string().required(),
        billing_phone: Yup.string().matches(
            /^[(\-.\s]?([0-9]{3})[)\-.\s]?\s?([0-9]{3})[(\-.\s]?([0-9]{4})$/,
            "Phone number must match 999-999-9999."
        ).required(),
        billing_work_phone: Yup.string().matches(
            /^[(\-.\s]?([0-9]{3})[)\-.\s]?\s?([0-9]{3})[(\-.\s]?([0-9]{4})$/,
            "Phone number must match 999-999-9999."
        ),
        billing_email: Yup.string().email().required(),
        info_street: Yup.string().required(),
        info_city: Yup.string().required(),
        info_state: Yup.string().nullable().oneOf(states, "State is not valid").required("State is required"),
        info_zip: Yup.string().required(),
        billing_street: Yup.string().when('hasAltAddress', {
            is: true,
            then: Yup.string(),
            otherwise: Yup.string().strip()
        }),
        billing_city: Yup.string().when('hasAltAddress', {
            is: true,
            then: Yup.string(),
            otherwise: Yup.string().strip()
        }),
        billing_state: Yup.string().when('hasAltAddress', {
            is: true,
            then: Yup.string().nullable().oneOf(states).required(),
            otherwise: Yup.string().strip()
        }),
        billing_zip: Yup.string().when('hasAltAddress', {
            is: true,
            then: Yup.string(),
            otherwise: Yup.string().strip()
        }),
    });
    const opts = states.map(s => s.replace('Select One', ''))
    const handler = useCallback(async (values) => {
        await dispatch(setPayorData(omitBy(values, isEmpty)));
        history.push('/checkout');
    }, [dispatch, history]);

    useEffect(() => {
        if (!parkers.length) history.push('/');
    }, [history, parkers.length]);
    return <Grid container>
        <Grid item xs={12}><LinearProgress variant="determinate" value={60} /></Grid>
        <Formik initialValues={init} onSubmit={handler} validationSchema={scheme}>
            {({ submitForm, values, errors, touched, dirty }) => <>
                <Grid item xs={12} md={7}>
                    <Box m={3}><Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Field component={ToggleButtonGroup} name="type" type="checkbox" exclusive>
                                <ToggleButton value="INDIVIDUAL" data-cy="individual-toggle-button">Individual</ToggleButton>
                                <ToggleButton value="BUSINESS" data-cy="business-toggle-button">Business</ToggleButton>
                            </Field>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h5">Primary Contact</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Field component={TextField} name="billing_firstname" placeholder="Jane" label="First Name"
                                fullWidth inputProps={{"data-cy": "billing-first-name-input"}}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Field component={TextField} name="billing_lastname" placeholder="Jane" label="Last Name"
                                fullWidth inputProps={{"data-cy": "billing-last-name-input"}}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Field component={TextField} name="billing_email" placeholder="jane@example.com"
                                label="Email" disabled={!!values.billing_email.length} fullWidth inputProps={{"data-cy": "billing-email-input"}}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Field component={TextField} name="billing_phone" placeholder="123-456-7890"
                                label="Phone Number" fullWidth inputProps={{"data-cy": "billing-phone-number-input"}}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Field component={TextField} name="billing_work_phone" placeholder="123-456-7890"
                                label="Work Phone Number" fullWidth inputProps={{"data-cy": "billing-work-phone-number-input"}}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Field component={TextField} name="info_street" placeholder="123 Main Street"
                                label="Street Address" fullWidth inputProps={{"data-cy": "info-address-input"}}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Field component={TextField} name="info_city" placeholder="Chicago" label="City"
                                fullWidth inputProps={{"data-cy": "info-city-input"}}/>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Field name="info_state" component={Autocomplete} options={opts} renderInput={(p) => {
                                const err = (touched.info_state || touched[p.id]) && !isEmpty(errors.info_state);
                                const txt = err ? errors.info_state : p.helperText
                                return <MuiTextField {...p} label="State" error={err} helperText={txt} fullWidth data-cy="info-state-text-field"/>
                            }} />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Field component={TextField} name="info_zip" placeholder="12345" label="Zip Code"
                                fullWidth inputProps={{"data-cy": "info-zip-code-input"}}/>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel label="Add a different Billing Address" control={
                                <Field name="hasAltAddress" type="checkbox" color="primary" component={Switch} data-cy="billing-address-switch" />
                            } />
                        </Grid>
                        {!!values.hasAltAddress ? <>
                            <Grid item xs={12}>
                                <Typography variant="h5">Billing Address</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Field component={TextField} name="billing_company_name" placeholder="Acme, INC."
                                    fullWidth label="Business" inputProps={{"data-cy": "business-billing-address-business-name-input"}}/>
                            </Grid>
                            <Grid item xs={12}>
                                <Field component={TextField} name="billing_attn" label="Attn" fullWidth inputProps={{"data-cy": "business-billing-address-attention-input"}}/>
                            </Grid>
                            <Grid item xs={12}>
                                <Field component={TextField} name="billing_street" placeholder="123 Main Street"
                                    label="Street Address" fullWidth inputProps={{"data-cy": "billing-address-address-input"}}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Field component={TextField} name="billing_city" placeholder="Chicago" label="City"
                                    fullWidth inputProps={{"data-cy": "billing-address-city-input"}}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Field name="billing_state" component={Autocomplete} options={opts} renderInput={(p) => {
                                    const err = (touched.billing_state || touched[p.id]) && !isEmpty(errors.billing_state);
                                    const txt = err ? errors.billing_state : p.helperText
                                    return <MuiTextField fullWidth {...p} label="State" error={err} helperText={txt} data-cy="billing-address-state-text-field"/>
                                }} />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Field component={TextField} name="billing_zip" placeholder="12345" label="Zip Code"
                                    fullWidth inputProps={{"data-cy": "billing-address-zip-code-input"}}/>
                            </Grid>
                        </> : ''}
                    </Grid></Box>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Box m={3}>
                        <PurchaseInfo
                            confirmOnRedirect={!!dirty}
                        />
                    </Box>
                </Grid>
                <Grid container item xs={12} justify="space-between">
                    <Box m={3}><Button size="large" variant="contained" color="secondary"
                        onClick={() => history.push('/survey')} data-cy="back-button">Back</Button></Box>
                    <Box m={3}><Button size="large" variant="contained" color="primary" disabled={isEmpty(authInfo)}
                        onClick={submitForm} data-cy="submit-form-button">Next</Button></Box>
                </Grid></>}
        </Formik>
    </Grid>
}

export default React.memo(PayorPage);
